<template>
    <div class="modal-window bds065">
      <!-- 보드복제 게시 팝업 S -->
      <div class="modal-header">
        <div class="tit">{{ $i18nUtil.trans("title.CopyBoardModal.002", "보드 복제") }}</div>
          <button @click="$emit('close')" class="btn_close">닫기</button>
        </div>

      <div class="modal-content">
        <div class="info-txt">{{ $i18nUtil.trans("message.CopyBoardModal.001", "보드를 복제할 위치를 지정해주세요.") }}</div>

        <div class="tab_ty3" id="tabsTy1">
          <ul class="tab-menu">
            <li v-for="(tab, index) in tabsTy1" v-bind:class="{active: tenantId == '201' ? currentTab1===1 : currentTab1===index}" :key="index">
                <input type="radio" name="tab" :id="index"><label :for="index" v-on:click="tenantId == '201' ? currentTab1 = 1 : currentTab1 = index">{{tab}}</label>
            </li>
          </ul>
          <div class="tab-content">
            <div v-show="currentTab1 == 0 && tenantId != '201'">

              <div class="tooltip-b tl small" :style="{'z-index': tooltip.zIndex, 'display': tooltip.display, 'bottom': tooltip.bottom, 'width': tooltip.width, 'left': tooltip.left}" style="position: absolute">
                {{ tooltipContent == null ? "" : tooltipContent }}
              </div>

              <div class="dropdown ty2 wide relative">
                  <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" class="ell-singleline" :class="copyCategoryName == '' ? 'disabled' : ''">{{copyCategoryName == "" ? $i18nUtil.trans("entity.category.depth2.search.select","과정 선택") : copyCategoryName}}</v-btn>
                      </template>
                      <div class="dropdown-list">
                          <div class="scroll">
                              <div class="dropdown-list-item" v-if="privateFolderList == null || privateFolderList.length == 0">
                                <div class="tit">
                                  <button type="button" class="disabled">{{$i18nUtil.trans("message.CopyBoardModal.002", "선택 가능한 과정이 없습니다.")}}</button>
                                </div>
                              </div>
                              <div 
                                v-else
                                class="dropdown-list-item" 
                                v-for="(privateFolderItem, privateFolderIndex) in privateFolderList" 
                                :value="privateFolderItem.category"
                                :key="privateFolderItem.category.categoryMid + '_' + privateFolderIndex"
                                @click="changePrivateFolder(privateFolderItem)"
                              >
                                <div class="tit">
                                  <button type="button" class="ell-singleline"
                                    @mouseover="mouseEvt(true, privateFolderItem.category.categoryName, $event)"
                                    @mouseleave="mouseEvt(false, null, $event)"
                                  >
                                    {{privateFolderItem.category.categoryName}}
                                  </button>
                                </div>
                              </div>
                          </div>
                      </div>
                  </v-menu>
              </div>

              <div class="error" v-if="privateError">{{$i18nUtil.trans('UB012', '과정을 선택해주세요.')}}</div>
              <footer class="modal-footer">
                <button type="button" class="btn_ty1" @click="copyBoard">{{ $i18nUtil.trans("button.copy", "복제") }}</button>
              </footer>
            </div>
            <div v-show="currentTab1 == 1">
              <!-- <form action="" onsubmit="return false;">
                <div class="search_ty1">
                  <input 
                    type="text" 
                    required 
                    placeholder="협업 멤버로 활동중인 과제명을 입력하세요."
                    v-model="searchProjectName"
                    @input="searchProjectName = $event.target.value, filterProject(searchProjectName)"
                    autocomplete="off"
                  />
                  <button type="reset" class="btn_search" @click="clearAndFilterProject(searchProjectName)">검색</button>
                  <div class="list scroll project-show" style="height: 100px" v-if="isProjectShow">
                    <ul>
                      <li 
                        v-for="(projectItem, projectIndex) in projectListFilter"
                        :value="projectItem"
                        :key="projectItem.projectId + `test`+projectIndex"
                        @click="changeProject(projectItem, $event)"
                      >
                        <button type="button">{{projectItem.projectName}}</button>
                      </li>
                    </ul>
                  </div>
                </div>
              </form> -->
              
              <div class="tooltip-b tl small" :style="{'z-index': tooltip.zIndex, 'display': tooltip.display, 'bottom': tooltip.bottom, 'width': tooltip.width, 'left': tooltip.left}" style="position: absolute">
                {{ tooltipContent == null ? "" : tooltipContent }}
              </div>

              <div class="search_ty1">
                <div class="dropdown ty2 wide relative">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" class="ell-singleline" v-on="on">{{searchProjectName == "" ? $i18nUtil.trans("entity.project.search.select", "과제 선택") : searchProjectName}}</v-btn>
                        </template>
                        <div class="dropdown-list">
                            <div class="scroll">
                                <div class="dropdown-list-item" v-if="projectListFilter == null || projectListFilter.length == 0">
                                  <div class="tit">
                                    <button type="button" class="disabled">{{$i18nUtil.trans("message.CopyBoardModal.003", "선택 가능한 과제가 없습니다.")}}</button>
                                  </div>
                                </div>
                                <div 
                                  v-else
                                  class="dropdown-list-item"
                                  v-for="(projectItem, projectIndex) in projectListFilter"
                                  :value="projectItem"
                                  :key="projectItem.projectId + `test`+projectIndex"
                                  @click="changeProject(projectItem, $event)"
                                >
                                  <div class="tit">
                                    <button type="button" class="ell-singleline"
                                      @mouseover="mouseEvt(true, projectItem.projectName, $event)"
                                      @mouseleave="mouseEvt(false, null, $event)"
                                    >
                                      {{ projectItem.projectName }}
                                    </button>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </v-menu>
                </div>
              </div>

              <div class="dropdown ty2 wide relative" :class="selectedProjectInfo == null ? 'disabled' : ''">
                  <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" class="ell-singleline" v-on="on" :class="copyProjectCategoryName == '' ? 'disabled' : ''">{{copyProjectCategoryName == "" ? $i18nUtil.trans("entity.category.depth2.search.select","과정 선택") : copyProjectCategoryName}}</v-btn>
                      </template>
                      <div class="dropdown-list">
                          <div class="scroll">
                              <div class="dropdown-list-item" v-if="projectFolderList == null || projectFolderList.length == 0">
                                <div class="tit">
                                  <button type="button" class="disabled">{{$i18nUtil.trans("message.CopyBoardModal.002")}}</button>
                                </div>
                              </div>
                              <div 
                                v-else
                                class="dropdown-list-item" 
                                v-for="(projectFolderItem, projectFolderIndex) in projectFolderList"
                                :value="projectFolderItem"
                                :key="projectFolderIndex"
                                @click="changeProjectFolder(projectFolderItem)"
                              >
                                <div class="tit">
                                  <button type="button" class="ell-singleline"
                                    @mouseover="mouseEvt(true, projectFolderItem.categoryName, $event)"
                                    @mouseleave="mouseEvt(false, null, $event)"
                                  >
                                    {{ projectFolderItem.categoryName }}
                                  </button>
                                </div>
                              </div>
                          </div>
                      </div>
                  </v-menu>
              </div>
              
              <div class="error" v-if="projectError">{{$i18nUtil.trans('UB012', '과정을 선택해주세요.')}}</div>

              <footer class="modal-footer">
                  <button type="button" class="btn_ty1" @click="copyBoard">{{ $i18nUtil.trans("button.copy", "복제") }}</button>
              </footer>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 보드복제 게시 팝업 E -->    
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";

export default {
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  components: {

  },
  data() {
    return {
      // 손해보험일 경우 프라이빗 제거
      tenantId: localStorage.getItem("tenantId"),
      browser: null,
      currentTab1: localStorage.getItem("tenantId") == '201' ? 1 : 0,
      tabsTy1: localStorage.getItem("tenantId") == '201' ? 
      [this.$i18nUtil.trans("entity.project", "과제")] : [this.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗"), this.$i18nUtil.trans("entity.project", "과제")],
      // tabsTy1: [this.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗"), this.$i18nUtil.trans("entity.project", "과제")],
      paperId: this.$props.modalInfo.paperId,
      groupId: this.$props.modalInfo.groupId,
      copyGroupId: "",
      copyCategoryMid: "",
      copyCategoryName: "",
      privateError: false,
      projectError: false,
      /* 나의 공간 */
      privateFolderList: [],
      selectedPrivateFolder: {},
      copyProjectGroupId: "",
      copyProjectCategoryMid: "",
      copyProjectCategoryName: "",
      searchProjectName: "",
      projectList: [],
      projectListFilter: [],
      selectedProjectInfo: null,
      isProjectShow: false,
      projectFolderList: [],
      selectedProjectFolder: {},
      toastInfo: {
          obj: this.$toasted,
          message: "",
          options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
          },
      },
      hover: false,
      tooltipFlag: false,
      tooltipContent: null,
      tooltip: {
        zIndex: 0,
        display: 'none',
        bottom: '0px',
        width: '0px',
        left: '30px'
      },
    }
  },
  created() {
    this.browser = this.$tooltip.checkBrowser();
  },
  mounted() {
    const self = this;
    // $("html").click(function (e) {
    //     if (!$(e.target).hasClass("project-show")) {
    //         self.isProjectShow = false;
    //     }
    // });
    /* 나의공간 폴더리스트 조회 */
    this.initPrivateFolderList();
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showToast", "showModal"]),

    mouseEvt(flag, title, event) {
      this.hover = flag;
      this.tooltipContent = title
      let val;
      if(this.browser === 'ie') {
        val = this.$tooltip.hasOverflownWidth(event.target);
      }else {
        val = this.$tooltip.hasOverflownHeightRemoveClass(event.target, "ell-singleline")
      }
      this.tooltipFlag = this.hover == true && val == true ? true : false
      this.activateTooltip(this.tooltipFlag, event);
    },
    activateTooltip(val, event) {
      let modalStyle = document.getElementsByClassName("v--modal-box")[0].getBoundingClientRect() // 모달의 style 정보;
      let loc = event.target.getBoundingClientRect().top; // 마우스 오버 타겟의 top
      loc = Math.abs(loc - modalStyle.bottom);
      // console.log("################ > ", loc);
      let width = event.target.getBoundingClientRect().width;

      if(val) {
        this.tooltip.zIndex = 13;
        this.tooltip.display = "inline-block";
        this.tooltip.width = width+'px';
        this.tooltip.bottom = loc+'px';
      }else{
        this.tooltip.zIndex = 0;
        this.tooltip.display = "none";
        this.tooltip.width = '0px';
        this.tooltip.bottom = '0px';
      }
    },
    /* 나의공간 폴더리스트 조회 */
    initPrivateFolderList() {
      let obj = this;
      let privateUrl = "/api/copaper/category/getGroupCategoryList";
      let param = {
        groupId: null,
      };
      axios
        .post(privateUrl, param)
        .then((res) => {
          if (res.errorCode != null && res.errorCode != undefined) {
            console.log('/getGroupCategoryList errorCode', res.errorCode);
            return;
          }
          obj.privateFolderList = res.data.result[0].list;
          obj.initProjectList();
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    initProjectList() {
      let obj = this;
      let projectUrl = "/api/cogroup/project/getMyProjectList";
      let param = {};
      axios
        .post(projectUrl, param)
        .then((res) => {
          if (res.errorCode != null && res.errorCode != undefined) {
            console.log('/getMyProjectList errorCode', res.errorCode);
            return;
          }
          obj.projectList = res.data.result.data;
          obj.selectedProjectInfo = null;
          obj.setProjectFilter();
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 나의 공간 폴더 변경 */
    changePrivateFolder(privateFolderInfo) {
      if(privateFolderInfo == null) {
        this.copyGroupId = null;
        this.copyCategoryMid = null;
        this.copyCategoryName = "";
      } else {
        this.copyGroupId = privateFolderInfo.category.groupId;
        this.copyCategoryMid = privateFolderInfo.category.categoryMid;
        this.copyCategoryName = privateFolderInfo.category.categoryName;
      }
    },
    clearAndFilterProject() {
      let obj = this;
      obj.searchProjectName = "";
      obj.copyProjectGroupId = null;
      obj.copyProjectCategoryMid = null;
      obj.copyProjectCategoryName = "";
      obj.filterProject(obj.searchProjectName);
      obj.isProjectShow = false;
      obj.selectedProjectInfo = null;
    },
    filterProject(searchProjectName) {
      let obj = this;
      if(obj.searchProjectName == '') {
        obj.changeProject(null);
      } else {
        obj.isProjectShow = true;
        obj.setProjectFilter();
      }
    },
    setProjectFilter() {
      let obj = this;
      if(obj.searchProjectName != null && obj.searchProjectName != '' && obj.projectList && obj.projectList.length > 0) {
        const result = obj.projectList.filter(function(projectObj){ 
          return projectObj.projectName.toLowerCase().indexOf(obj.searchProjectName.toLowerCase()) > -1;
        }); 
        obj.projectListFilter = result;
      } else {
        obj.projectListFilter = obj.projectList;
      }
    },
    changeProject(projectInfo) {
      let obj = this;
      obj.isProjectShow = false;
      obj.selectedProjectInfo = projectInfo;
      obj.copyProjectGroupId = null;
      obj.copyProjectCategoryMid = null;
      obj.copyProjectCategoryName = "";
      if(projectInfo != null && projectInfo.projectId != null && projectInfo.projectId != undefined) {
        obj.searchProjectName = projectInfo.projectName;
        let projectFolderUrl = "/api/copaper/category/getCategoryItemList";
        let param = {
          categoryMid: null,
          groupId: projectInfo.groupId,
          type: "PROJECT"
        };
        axios
          .post(projectFolderUrl, param)
          .then((res) => {
            if (res.errorCode != null && res.errorCode != undefined) {
              console.log('copy board modal res errorCode : ', res.errorCode);
              return;
            }
            obj.projectFolderList = res.data.result;
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      } else {
        obj.projectFolderList = [];
      }
    },
    /* 나의 공간 폴더 변경 */
    changeProjectFolder(projectFolderInfo) {
      if(projectFolderInfo == null) {
        this.copyProjectGroupId = null;
        this.copyProjectCategoryMid = null;
        this.copyProjectCategoryName = "";
      } else {
        this.copyProjectGroupId = projectFolderInfo.groupId;
        this.copyProjectCategoryMid = projectFolderInfo.categoryMid;
        this.copyProjectCategoryName = projectFolderInfo.categoryName;
      }

    },
    /* 보드복제 */
    copyBoard() {
      let obj = this;
      if(this.currentTab1 != 0 && this.currentTab1 != 1) {
        return;
      }
      let reqCopyGroupId = null;
      let reqCopyCategoryMid = null;
      if(this.currentTab1 == 0) {
        if(this.copyGroupId === null || this.copyGroupId === undefined || this.copyGroupId === ""
            || this.copyCategoryMid === null || this.copyCategoryMid === undefined || this.copyCategoryMid === ""
        ) {
            if(this.currentTab1 == 0) {
              this.privateError = true;
            }
            return;
        }
        reqCopyGroupId = this.copyGroupId;
        reqCopyCategoryMid = this.copyCategoryMid;
      }
      else if(this.currentTab1 == 1) {
        if(this.copyProjectGroupId === null || this.copyProjectGroupId === undefined || this.copyProjectGroupId === ""
            || this.copyProjectCategoryMid === null || this.copyProjectCategoryMid === undefined || this.copyProjectCategoryMid === ""
        ) {
          if(this.currentTab1 == 1) {
            this.projectError = true;
            }
            return;
        }
        reqCopyGroupId = this.copyProjectGroupId;
        reqCopyCategoryMid = this.copyProjectCategoryMid;
      }

      this.privateError = false;
      this.projectError = false;

      let copyUrl = "/api/copaper/paper/copyPaper";
      if(this.$props.modalInfo.hoToBoard){
        copyUrl = "/api/copaper/paper/copyHoPaper";
      }
      let param = {
        paperId: this.paperId,
        groupId: reqCopyGroupId,
        categoryMid: reqCopyCategoryMid,
        kind: this.tenantId == '201' ? 'PROJECT' : this.currentTab1 == 0 ? 'PRIVATE' : 'PROJECT'
      };
      obj.showLoadingbar();
      axios
        .post(copyUrl, param)
        .then((res) => {
          obj.hideLoadingbar();
          // res.data.errorCode = "COFILE_STORAGE_CAPACITY_EXCEEDED";
          if (res.data.errorCode && res.data.errorCode != null && res.data.errorCode != undefined && res.data.errorCode.length > 0) {
            if(res.data.errorCode == "COPY_KIND_REQUIRED") {
              // obj.showAlertDialog("선택한 단계의 용량이 초과되어 복제/이관할 수 없습니다.\n위치 변경 또는 공간 용량을 확인해주세요.");
              obj.showAlertDialog(obj.$i18nUtil.trans('message.CopyBoardModal.004', '프라이빗/과제를 선택해주세요.'));
            }
            else if(res.data.errorCode == "COFILE_STORAGE_CAPACITY_EXCEEDED") {
              // obj.showAlertDialog("선택한 단계의 용량이 초과되어 복제/이관할 수 없습니다.\n위치 변경 또는 공간 용량을 확인해주세요.");
              obj.showAlertDialog(obj.$i18nUtil.trans('AB035', '선택한 과정의 용량이 초과되어 복제/이관할 수 없습니다.\n위치 변경 또는 공간 용량을 확인해주세요.'));
            }
            return;
          }
          // obj.toastInfo.message = "보드가 복제되었습니다.";
          obj.toastInfo.message = obj.$i18nUtil.trans("TB019", "보드가 복제되었습니다.");
          obj.showToast(obj.toastInfo);
          obj.$emit("close");
        })
        .catch((err) => {
          obj.hideLoadingbar();
          console.log("axios err => ", err);
        });
      // this.$emit("close");
    },
  },
  watch: {
  }
}
</script>

<style scoped>
.bds065 .tab-content .modal-footer {
  margin-top: 30px;
}

#modals-container >>> .v--modal-overlay .v--modal-box.v--modal {
  overflow: visible;
} 

.bds065 .tab-content .dropdown.ty2 .dropdown-list > .scroll > div:nth-child(2) > .tit > .tooltip-b {
    display: none;
    position: absolute; left: 0; top: 30px;
    z-index: 10;
    word-break: break-all;
    word-wrap: break-word;
}
.bds065 .tab-content .dropdown.ty2 .dropdown-list > .scroll > div:nth-child(2) > .tit > .tooltip-b {
    top: auto; bottom: 30px;
    margin-top: 0;
    /* margin-bottom: 7px; */
    width: inherit;
}
.tooltip-b.tl::before, .tooltip-w.tl::before {
  top: auto;
  bottom: -6px;
  -webkit-transform: rotate(
    180deg
  );
  transform: rotate(
    180deg
    );
}
.bds065 .tab-content .dropdown.ty2 .dropdown-list > .scroll > div:nth-child(2) > .tit > .tooltip-b::before {
    top: auto; bottom: -8px;
    transform: rotate(180deg);
}
.bds065 .tab-content .dropdown.ty2 .dropdown-list > .scroll > div:nth-child(2) > .tit > button:hover + .tooltip-b {
  display: inline-block;
}
.bds065 .tab-content .dropdown.ty2 .dropdown-list > .scroll > div:nth-child(2) > .tit {
    width: 100%;
    -ms-flex-item-align: center;
    align-self: center;
    /* text-overflow: ellipsis; */
    white-space: initial;
}

.dropdown-list-item .tit {
  white-space: initial !important;
}

</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/CopyBoardModal.vue